import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LoadingSpinnerModule } from '../../components/loading-spinner/loading-spinner..module';

import { RequestPasswordComponent } from './request-password.component';

@NgModule({
  declarations: [
    RequestPasswordComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingSpinnerModule
  ],
  exports: [
    RequestPasswordComponent
  ],
  providers: []
})
export class RequestPasswordModule { }


